"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VendorLoadError = void 0;
var _react = _interopRequireWildcard(require("react"));
var _LargeError = require("./LargeError");
var _StudioLogger = require("@studio/logger/StudioLogger");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var LOG = new _StudioLogger.StudioLogger('vendor-load-error');
/**
 * VendorLoadError component displays an error message when the vendor flag does not return either of the expected vendors (Agora or Chime).
 * This indicates that there was an issue loading the studio page, which could be due to a variety of reasons such as network issues, server errors, or misconfiguration of feature flags.
 * This component logs the error to the console and renders a user-friendly error message
 * with instructions to refresh the browser or contact support.
 *
 * @component
 * @returns {React.ReactElement} A LargeError component with vendor load error message
 *
 * @example
 * return (
 *   <VendorLoadError />
 * )
 */
var VendorLoadError = exports.VendorLoadError = function VendorLoadError() {
  (0, _react.useEffect)(function () {
    LOG.error('VendorLoadError - An error occurred while loading the studio page');
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_LargeError.LargeError, {
    description: "There was a problem loading this page. Please try a browser refresh and if the problem persists, reach out to client support."
  });
};